export default __webpack_public_path__ + "static/bunker-phones-1-65145eacfc6f2512e04fe07a8f6a90c5.jpg";